<template>
  <div>
    <div>
      <van-nav-bar :title="$t('details.title')" left-arrow @click-left="onClickLeft">
        <template #left>
          <van-icon name="arrow-left" size="22" color="#fff" />
        </template>
      </van-nav-bar>
    </div>
    <div class="feiziInfo">
      <!-- 大图区域 -->
      <div class="bigImageBox">
        <div class="big-image-wrapper">
          <transition name="fade-scale" mode="out-in">
            <img
              :key="currentImage"
              :src="currentImage || '/img/error.png'"
              class="big-image"
              onerror="this.src='/img/error.png'"
            />
          </transition>
        </div>
      </div>

      <!-- 照片列表 -->
      <div class="photoListBox">
        <div class="imgswiper">
          <div
            v-for="(i,index) in data.img_url"
            :key="index"
            class="photo-item"
            @click="onClickImg(index)"
          >
            <div
              :class="['photo-wrapper', { active: currentIndex === index }]"
            >
              <img
                :src="i || '/img/error.png'"
                class="photo-img"
                onerror="this.src='/img/error.png'"
              />
              <div v-if="currentIndex !== index" class="photo-mask"></div>
            </div>
          </div>
        </div>
      </div>

      <div style="padding-bottom: 2vw; background-color: #ebedf0;"></div>

      <!-- 详情区域 -->
      <div class="detailInfo">
        <div class="dianzanimg" @click="clickPraise">
          <div class="van-image" style="width: 60px; height: 60px;">
            <img
              src="/img/zan.c28032c8.png"
              class="van-image__img"
              style="object-fit: cover;"
            />
          </div>
          <p style="color: rgb(107, 34, 179); margin: 0px;">
            {{ data.dianzan }}
          </p>
        </div>

        <div class="detail-header">
          <span class="name">{{ data.xuanfei_name }}</span>
          <div class="auth-badges">
            <div>
              <div class="van-image" style="width: 18px;">
                <img
                  src="/img/vip.png"
                  style="width: 18px; height: 18px;"
                  class="van-image__img"
                />
              </div>
              <span>{{$t("index.authentication")}}</span>
            </div>
            <div>
              <div class="van-image" style="width: 18px;">
                <img
                  src="/img/vip.png"
                  class="van-image__img"
                  style="width: 18px; height: 18px;"
                />
              </div>
              <span>{{$t("index.video_authentication")}}</span>
            </div>
          </div>
        </div>

        <div style="color: #6b22b3; font-size: 3vw; margin: 5px 0;">
          {{$t("index.height")}}:{{ data.hight }} {{$t("index.bust")}}：{{ data.bust }}
        </div>

        <div style="width: 100%; margin: 5px 0;">
          <div class="item" v-for="(item,index) in data.flagArray" :key="index">{{item}}</div>
        </div>

        <div style="margin: 5px 0;">
          <span style="color: rgb(107, 34, 179); font-size: 14px;">{{$t("index.toll")}}：</span>
          <van-rate v-model="data.number" readonly color="#ffd21e" size="18px" />
        </div>

        <div style="color: rgb(107, 34, 179); font-size: 14px; margin: 5px 0;">
          {{$t("index.residence")}}：{{ data.address }}
        </div>

        <div class="yuyueBox" @click="getUserGameList">
          {{$t("index.instant_booking")}}
        </div>
      </div>
      <div style="padding-bottom: 2vw; background-color: #ebedf0;"></div>

      <!-- 个人简介 -->
      <div class="profileInfo">
        <div style="color: rgb(42, 20, 104); margin-bottom: 10px; font-weight: bold; font-size: 16px;">
          {{ $t('details.personal_profile') }}
        </div>
        <div style="color: rgb(83, 69, 137); line-height: 1.6;">
          {{ data.jianjie }}
        </div>
      </div>
    </div>
    <div style="padding-bottom: 2vw; background-color: #ebedf0;"></div>
  </div>
</template>

<script>
import { Base64 } from 'js-base64';
import { getCurrentLang } from '../../common/lang';

export default {
  data() {
    return {
      data: {},
      currentIndex: 0,
      currentImage: '',
      isPraised: false,
    };
  },
  methods: {
    getxuanfeidata() {
			this.$http({
				method: 'get',
				url: 'xuanfeidata',
				data: { id: this.$route.query.id }
			}).then(res => {
        // 解码Base64数据
        if (typeof res.data === 'string') {
          try {
            this.data = JSON.parse(Base64.decode(res.data));
          } catch (e) {
            console.error('Base64 decode failed:', e);
            this.data = res.data;
          }
        } else {
          this.data = res.data;
        }

        // 根据当前语言选择对应的标签
        const parts = this.data.flag.split('|');
        const langMap = {
          'zh': 0,
          'en': 1,
          'ja': 2,
          'de': 3,
          'kr': 3,
          'mn': 3
        };
        const currentLang = getCurrentLang();
        const langIndex = langMap[currentLang] || 0;
        this.data.flag = parts[langIndex] || parts[0];
        this.data.flagArray = this.data.flag.split('，');

        // 默认选中第一张照片
        this.currentIndex = 0;
        this.currentImage = this.data.img_url[0];
			});
    },

    onClickImg(index) {
      this.currentIndex = index;
      this.currentImage = this.data.img_url[index];
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    clickPraise() {
      if (this.isPraised) {
        // 如果已经点赞，则减1
        this.data.dianzan --;
        this.isPraised = false;
      } else {
        // 如果未点赞，则加1
        this.data.dianzan ++;
        this.isPraised = true;
      }
    },
    getUserGameList(){
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res=>{
        if(res.code === 200){
          this.$toast(res.msg);
          this.list = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    this.getxuanfeidata();
  },
};
</script>

<style scoped lang="less">
.van-nav-bar {
  background: transparent !important;
}
::v-deep .van-nav-bar__title {
  color: #000;
}
.van-nav-bar .van-icon {
  color: #000 !important;
}
.feiziInfo {
  background: #ebedf0;
}

/* 大图区域 */
.bigImageBox {
  background: #fff;
  padding: 20px 15px;
  display: flex;
  justify-content: center;
  align-items: center;

  .big-image-wrapper {
    width: 98%;
    max-width: 480px;
    aspect-ratio: 2.5 / 4; /* 竖向比例,更高 */
    overflow: hidden;
    border-radius: 12px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
    transform: translateY(0);
    transition: all 0.3s ease;
  }

  .big-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

/* 小屏幕适配 */
@media screen and (max-width: 375px) {
  .bigImageBox {
    padding: 10px 8px;

    .big-image-wrapper {
      width: 80%;
      max-width: 280px;
      max-height: 50vh;
    }
  }
}

/* 照片列表区域 */
.photoListBox {
  background: #fff;
  padding: 15px 10px;
}

.imgswiper {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  padding: 5px 0;

  /* 隐藏滚动条但保持滚动功能 */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.photo-item {
  flex-shrink: 0;
  width: 150px;
  height: 200px;
}

/* 小屏幕适配 */
@media screen and (max-width: 375px) {
  .photo-item {
    width: 110px;
    height: 145px;
  }
}

.photo-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

  &.active {
    transform: translateY(-8px) scale(1.05);
    box-shadow: 0 12px 24px rgba(229, 72, 120, 0.4);
  }
}

.photo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.photo-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
}

/* 个人简介区域 */
.profileInfo {
  padding: 20px;
  background: #fff;

  > div:first-child {
    font-size: 16px;
    font-weight: 600;
  }

  > div:last-child {
    font-size: 4vw;
    margin-top: 8px;
  }
}

/* 详情区域 */
.detailInfo {
  position: relative;
  padding: 20px;
  background: #fff;

  .detail-header {
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;

    .name {
      color: #2c1868;
      font-size: 6vw;
      font-weight: bold;
    }

    .auth-badges {
      display: flex;
      gap: 10px;

      > div {
        display: flex;
        align-items: center;
        background: linear-gradient(180deg, #e7caaf, #fff7ed);
        color: #a4826b;
        font-weight: 600;
        font-size: 3.5vw;
        padding: 4px 6px;

        .van-image {
          margin-right: 3px;
        }
      }
    }
  }

  .item {
    background: linear-gradient(50deg, #9b54ca, #e6557f);
    color: #fff;
    display: inline-block;
    border-radius: 20px;
    margin-right: 10px;
    font-size: 3.5vw;
    padding: 8px 16px;
    margin-bottom: 10px;
  }

  .yuyueBox {
    margin-top: 20px;
    color: #fff;
    padding: 15px 30px;
    background: linear-gradient(20deg, #e73266, #ee5380);
    border-radius: 25px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;

    &:active {
      transform: scale(0.98);
    }
  }

  .dianzanimg {
    position: absolute;
    top: 60px;
    right: 20px;
    text-align: center;
    cursor: pointer;
    z-index: 10;
  }
}

/* 大图切换动画 */
.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 0.4s ease;
}

.fade-scale-enter {
  opacity: 0;
  transform: scale(0.95);
}

.fade-scale-leave-to {
  opacity: 0;
  transform: scale(1.05);
}

.fade-scale-enter-to {
  opacity: 1;
  transform: scale(1);
}
</style>
